import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { VeeVal } from "./VeeValidateHelper";
import VueScript2 from "vue-script2";
import VModal from "vue-js-modal";
import MaskedInput from "vue-text-mask";
import MsalInstance from "./plugins/MsalInstance";
import AppConstants from "./plugins/AppConstants";

Vue.use(VeeVal);
Vue.use(VueScript2);
Vue.use(VModal);
Vue.use(MsalInstance);
Vue.use(AppConstants);
Vue.component("masked-input", MaskedInput);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
